import DivisionService from "@/services/division-service";
import RoleService from "@/services/role-service";

export default {
  async getDivisions({ commit }, model) {
    return await DivisionService.getDivisions({ params: model }).then(
      (result) => {
        /* This is a mutation that is being called in the JavaScript file. */
        if (result.data && result.data.length > 0) {
          commit("DIVISIONS_SUCCESS", result.data);
        }
        return Promise.resolve(result.data);
      },
      (error) => {
        commit("DIVISIONS_FAILURE");
        return Promise.reject(error);
      }
    );
  },

  async getRoles({ commit }, model) {
    return await RoleService.getRoles({ params: model }).then(
      (result) => {
        /* This is a mutation that is being called in the JavaScript file. */
        if (result.data && result.data.length > 0) {
          commit("ROLES_SUCCESS", result.data);
        }
        return Promise.resolve(result.data);
      },
      (error) => {
        commit("ROLES_FAILURE");
        return Promise.reject(error);
      }
    );
  }
};
